import {
  JbIntElementInit
} from "./chunk.62T75WFP.js";
import {
  __decorateClass
} from "./chunk.Y3TZ4FJV.js";

// src/components/interactive-animation/interactive-animation.ts
import "@lottiefiles/lottie-player";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
var JbIntElement = JbIntElementInit();
var JbIntInteractiveAnimation = class extends JbIntElement {
  constructor() {
    super(...arguments);
    this.bounce = false;
    this.hover = false;
    this.loop = false;
    this.playing = false;
    this._player = createRef();
  }
  firstUpdated() {
    setTimeout(() => this._updatePlaying());
  }
  requestUpdate(name, oldValue, options) {
    if (name === "playing" && this._player?.value && this.playing) this._onMouseEnter();
    else if (name === "playing" && this._player?.value && this.playing === false) this._onMouseLeave();
    else super.requestUpdate(name, oldValue, options);
  }
  _onComplete() {
    this.emit(
      new CustomEvent("complete", { detail: { playing: this.playing } })
    );
  }
  _onMouseEnter() {
    this._player.value.seek(0);
    this._player.value.setDirection(1);
    this._player.value.play();
  }
  _onMouseLeave() {
    if (this.bounce) {
      this._player.value.setDirection(-1);
      this._player.value.play();
    } else {
      this._player.value.stop();
    }
  }
  _updatePlaying() {
    this._player.value.stop();
    if (this.playing) this._player.value.play();
  }
  /**
   * Main render method of the component.
   * @returns Template of interactive-animation component.
   */
  render() {
    return html`
      <lottie-player
        ${ref(this._player)}
        ?loop=${this.loop}
        .speed=${this.speed ?? nothing}
        src="${this.animationFile}"
        @mouseenter=${() => this.hover && this._onMouseEnter()}
        @mouseleave=${() => this.hover && this._onMouseLeave()}
        @complete=${() => this._onComplete()}
        @stop=${() => this._onComplete()}
      ></lottie-player>
    `;
  }
};
__decorateClass([
  property()
], JbIntInteractiveAnimation.prototype, "animationFile", 2);
__decorateClass([
  property({ type: Boolean })
], JbIntInteractiveAnimation.prototype, "bounce", 2);
__decorateClass([
  property({ type: Boolean })
], JbIntInteractiveAnimation.prototype, "hover", 2);
__decorateClass([
  property({ type: Boolean })
], JbIntInteractiveAnimation.prototype, "loop", 2);
__decorateClass([
  property({ type: Boolean })
], JbIntInteractiveAnimation.prototype, "playing", 2);
__decorateClass([
  property({ type: Number })
], JbIntInteractiveAnimation.prototype, "speed", 2);
JbIntInteractiveAnimation = __decorateClass([
  customElement("jb-int-interactive-animation")
], JbIntInteractiveAnimation);

export {
  JbIntInteractiveAnimation
};
